import { render, staticRenderFns } from "./business.vue?vue&type=template&id=a80c357c&scoped=true"
import script from "./business.vue?vue&type=script&lang=ts"
export * from "./business.vue?vue&type=script&lang=ts"
import style0 from "./business.vue?vue&type=style&index=0&id=a80c357c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80c357c",
  null
  
)

export default component.exports